module.exports = __webpack_public_path__ + "img/social-fashion-vote.4305b4bf.jpg";